/** IMEI válido: exactamente 15 dígitos (patrón central de type-kit). */
export { IMEI_PATTERN } from '@fiado/type-kit/bin/common/constants/InputPatterns';
